import React from 'react'
import './Dropdown.css'

const Dropdown = ({ label, value, options, onChange }) => {
    return (
      <label>
        <span style={{fontWeight:"bold"}}>{label}</span>
        {options.length !== 0 ?
            <select value={value} onChange={onChange}>
                {options.map((option) => (
                <option value={option.value} key={option.label}>{option.label}</option>
                ))}
            </select> :
            <select value={value} onChange={onChange} disabled>
            </select>
        }
      </label>
    );
  };

  export default Dropdown;



